import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

const nav = [
  { label: 'Menu', href: '/menu' },
  { label: 'Story', href: '/about' },
  { label: 'Locations', href: '/locations' },
  { label: 'Contact', href: '/contact' },
];

export default function Footer() {
  return (
    <footer className="relative bg-primary-500 text-background-50 overflow-hidden border-t-[2.5px] border-foreground-950">
      <div className="absolute inset-0 halftone-light pointer-events-none" aria-hidden="true" />
      <div className="wrap relative pt-16 md:pt-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 pb-12 items-start" data-m-group>
          <div className="md:col-span-6" data-m="up">
            <p className="h-section">Get messy.<br />Stay loud.</p>
            <span className="hand mt-4 inline-block text-xl tilt-xs">— see you at the counter</span>
          </div>
          <ul data-m="fade" className="md:col-span-6 flex flex-wrap md:justify-end items-start gap-3">
            {nav.map((n) => (
              <li key={n.label}>
                <Link to={n.href} className="btn-poster btn-paper btn-sm">{n.label}</Link>
              </li>
            ))}
            <li>
              <span className="sticker bg-foreground-950 text-background-50 tilt-r" title="Instagram link coming soon">IG — soon!</span>
            </li>
          </ul>
        </div>
        <p data-m="letters" className="display text-[21vw] leading-[0.82] text-foreground-950 pt-6 select-none text-center" aria-hidden="true">
          {'Fire Club'.split('').map((ch, i) => (
            <span key={`${ch}-${i}`} className="m-letter-mask">
              <span className="m-letter" style={{ '--i': i } as CSSProperties}>{ch === ' ' ? '\u00a0' : ch}</span>
            </span>
          ))}
        </p>
      </div>
      <div className="wrap relative flex flex-col sm:flex-row justify-between gap-2 py-6 mt-6 dash-line !border-background-50/50 text-xs text-background-50/85">
        <span>© 2026 Fire Club Burger &amp; Grill. All rights reserved.</span>
        <span className="hand text-sm">smash burgers · open flame · made fresh</span>
      </div>
    </footer>
  );
}